import Grid2 from "@mui/material/Unstable_Grid2";
import React from "react";

const NotesSection = ({notes}) => {

    return (
        <>
            <Grid2 container spacing={2}>
                {notes?.map((e) => (
                    <Grid2 key={e.id} xs={12} md={6}>
                        <div className='background-secondary-color-3 rounded-lg p-3'>
                            <p className='text-md font-weight-bold text-color-1'>{e.title}</p>
                            <div className='text-sm text-lowercase text-color-1' dangerouslySetInnerHTML={{__html: e.msg}}/>
                        </div>
                    </Grid2>
                ))}
            </Grid2>
        </>
    );
}

export default NotesSection;